module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00411.fc497eb1.jpg";